import React from "react";
import { Box, Stack } from "@mui/material";
import { FieldLabel } from "../../../../components/fields/FieldLabel/FieldLabel";
import previewImg from "../../../../assets/svg/image_placeholder.svg";
import { ImageProps } from "./constants";
import { IconProduct } from "../../../../utils/icons";
import { Button } from "../../../../components/Button/Button";

interface Props {
  image?: ImageProps;
  setImage: (image: ImageProps) => void;
  label?: string;
  inputName?: string;
  height?: number;
  width?: number;
}

export function ProductImage({
  image,
  setImage,
  label = "Product Image",
  inputName = "avatar",
  height = 112,
  width = 112,
}: Props) {
  const handleAvatarClick = () => {
    document.getElementsByName(inputName)[0].click();
  };

  const imageChange = (event: any) => {
    const { files } = event.target;
    if (files.length > 0) {
      const target = files[0];
      if (target.size < 200000000) {
        const fReader = new FileReader();
        fReader.readAsDataURL(target);
        fReader.onloadend = function (e: any) {
          const newImage = {
            source: e.target.result,
            file: target,
            error: "",
            extension: target.type.replace("image/", ""),
          };
          setImage(newImage);
        };
      } else {
        setImage({
          source: previewImg,
          file: undefined,
          error: "File exceeds maximum upload size of 200 MB.",
        });
      }
    }
  };

  return (
    <Stack className="!mt-0">
      <FieldLabel required={false}>{label}</FieldLabel>

      <input
        type="file"
        accept="image/*"
        name={inputName}
        onChange={imageChange}
        style={{ display: "none" }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 2, sm: 6 },
        }}
      >
        <Box>
          <Box
            sx={{
              height: { xs: Math.min(height, 140), sm: height },
              width: { xs: Math.min(width, 140), sm: width },
            }}
            onClick={handleAvatarClick}
            className="cursor-pointer hover:opacity-80"
          >
            {image?.source ? (
              <img
                src={image.source}
                alt="pro headshot"
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <Box className="flex h-full w-full items-center justify-center bg-surface-2 rounded-xl">
                <IconProduct />
              </Box>
            )}
          </Box>
          {image?.error ? (
            <div className="text-left text-error text-xs font-bold mt-1 ">
              {image.error}
            </div>
          ) : null}
        </Box>
        <Button
          className="h[40px] w-[100px] !px-4 !py-2"
          onClick={handleAvatarClick}
        >
          {!image?.source ? "Upload" : "Replace"} Image
        </Button>
      </Box>
    </Stack>
  );
}
